import { ISize } from 'shared/types/Size';

export const getSizeOption = (sizeInput: string | number, sizeOptions: ISize[]): ISize => {
  const sizeOption = sizeOptions?.find((option) => option.value === sizeInput);
  if (!sizeOption?.value || !sizeOption?.presentation) {
    return null;
  }
  return sizeOption;
};
